// @core/api/endpoints/attachment/retry_processing.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AttachmentResponse,
  RetryProcessingRequest,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Retry failed attachment processing
 * Re-queues failed processing tasks for an attachment. Can retry all failed tasks or specify individual task names to retry.
 */
export async function RetryProcessing(
  attachment_id: string,
  data: RetryProcessingRequest,
  options?: RequestOptions
): Promise<AttachmentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/attachments/:attachment_id/retry-processing`;
  requestPath = requestPath.replace(':attachment_id', encodeURIComponent(attachment_id));
  const requestOptions = options;
  return client.post<AttachmentResponse>(requestPath, data, requestOptions);
}
